import React from "react";

/**
 * Shared trash/delete icon for file rows (Continuous Compliance, Risk Analysis, Mock Survey, etc.).
 */
export function DeleteFileIcon(): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      aria-hidden
    >
      <path
        d="M6.5 2.5H9.5C9.5 1.67157 8.82843 1 8 1C7.17157 1 6.5 1.67157 6.5 2.5ZM5.5 2.5C5.5 1.11929 6.61929 0 8 0C9.38071 0 10.5 1.11929 10.5 2.5H15.5C15.7761 2.5 16 2.72386 16 3C16 3.27614 15.7761 3.5 15.5 3.5H14.4456L13.2521 13.8439C13.0774 15.3576 11.7957 16.5 10.2719 16.5H5.72813C4.20431 16.5 2.92256 15.3576 2.7479 13.8439L1.55437 3.5H0.5C0.223858 3.5 0 3.27614 0 3C0 2.72386 0.223858 2.5 0.5 2.5H5.5ZM3.74131 13.7292C3.85775 14.7384 4.71225 15.5 5.72813 15.5H10.2719C11.2878 15.5 12.1422 14.7384 12.2587 13.7292L13.439 3.5H2.56101L3.74131 13.7292ZM6.5 6C6.77614 6 7 6.22386 7 6.5V12.5C7 12.7761 6.77614 13 6.5 13C6.22386 13 6 12.7761 6 12.5V6.5C6 6.22386 6.22386 6 6.5 6ZM10 6.5C10 6.22386 9.77614 6 9.5 6C9.22386 6 9 6.22386 9 6.5V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V6.5Z"
        fill="#262626"
      />
    </svg>
  );
}
